export default "__VITE_ASSET__CO$5zCCv__"